import { useEffect, useState } from "react"
import { checkIfLocalStorageIsSupportedByBrowser } from "../local-storage"
import { BookingRouter } from "../routing"

const featureEnabled = (name: string) => `${name}=true`
const featureDisabled = (name: string) => `${name}=false`

const activeFeatureFlags = ["unbundling", "flights-step"] as const
export type ActiveFeatureFlags = (typeof activeFeatureFlags)[number]

export const useFeatureFlag = (name: ActiveFeatureFlags) => {
    const [isEnabled, setIsEnabled] = useState(false)
    const isLocalStorageEnabled = checkIfLocalStorageIsSupportedByBrowser()

    useEffect(() => {
        if (window.location.search.includes(featureEnabled(name))) {
            if (isLocalStorageEnabled) window.localStorage.setItem(name, "true")
            setIsEnabled(true)
            return
        }
        if (window.location.search.includes(featureDisabled(name))) {
            if (isLocalStorageEnabled) window.localStorage.removeItem(name)
            setIsEnabled(false)
            return
        }
        if (checkIfLocalStorageIsSupportedByBrowser() && window.localStorage.getItem(name) === "true") {
            setIsEnabled(true)
            return
        }
    }, [])

    return isEnabled
}

export const featureFlag = (name: ActiveFeatureFlags, router: BookingRouter) => router.query[name] === "true"
